import React, { Component, Fragment } from "react";
import { themeService } from "../../theme/service/activeTheme.service";
import { switchReportStyle } from "../Reports/sims/style";
import { updateFilterState } from "../../reduxRelated/actions/filterStateAction.js";
import { getAllInspectableAssets } from "../../reduxRelated/actions/assetHelperAction.js";
import { CRUDFunction } from "../../reduxCURD/container.js";
import moment from "moment";
import { trackReportStyle } from "../Reports/Timps/style/index.js";
import SpinnerLoader from "../Common/SpinnerLoader.js";
import { Col, Row } from "reactstrap";
import { languageService } from "../../Language/language.service.js";
import DateRangeControl from "../Common/DateRange/DateRangeControl.jsx";
import { ButtonActionsTable } from "components/Common/Buttons";
import ViewOemReport from "./viewOEMReport/ViewOemReport.jsx";
import { arrowLeft } from "react-icons-kit/icomoon/arrowLeft.js";
import { printer } from "react-icons-kit/icomoon/printer.js";
import SvgIcon from "react-icons-kit";
import { curdActions } from "../../reduxCURD/actions.js";
import ViewReportOfOEMContainer from "../AssetView/OEM/ViewReport/ViewReport.jsx";
import OEMReportContainer from "./viewOEMReport/OEMReportContainer.jsx";
import { versionInfo } from "../MainPage/VersionInfo.js";

class LocomotiveOEM extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assets: [],
      oemDetails: [],
      showOEM: {
        show: false,
        selectedAsset: null,
        OEMData: null,
      },
    };
    this.renderTable = this.renderTable.bind(this);
  }
  componentDidMount() {
    this.props.getLocomotiveOEMAssets();
    this.props.getApplicationlookupss("/getlist/MaintenanceOEM");
  }
  componentDidUpdate(prevProps) {
    if (prevProps.actionType != this.props.actionType && this.props.actionType === "LOCOMOTIVEOEMASSETSS_READ_SUCCESS") {
      this.setState({
        assets: this.props.LocomotiveOEMAssetss.assets,
      });
    }
    if (
      prevProps.applicationlookupsActionType != this.props.applicationlookupsActionType &&
      this.props.applicationlookupsActionType === "APPLICATIONLOOKUPSS_READ_SUCCESS"
    ) {
      this.setState({
        oemDetails: this.props.applicationlookupss,
      });
    }
  }
  renderTable() {
    const { assets, oemDetails } = this.state;

    let rows = assets.map((e, i) => {
      const configured = e.OEMDetails;
      let oem = null;
      if (configured) {
        oem = oemDetails.find((oe) => oe.code === configured.code);
      }
      if (versionInfo.isReVAMP() && configured && oem)
        return (
          <tr key={i}>
            <td>{e.unitId}</td>
            <td>
              {configured && (
                <ButtonActionsTable
                  handleClick={(event) => {
                    this.setState({
                      showOEM: {
                        show: true,
                        selectedAsset: e,
                        OEMData: oem,
                      },
                    });
                  }}
                  margin="0px 10px 0px 0px"
                  buttonText={languageService("View")}
                />
              )}
            </td>
          </tr>
        );
    });
    return (
      <div
        className="mainContent table-report switch-side-track report-selection"
        style={{ ...themeService(trackReportStyle.mainStyle), background: "transparent" }}
      >
        <Row>
          <Col md={1}></Col>
          <Col md={10}>
            <table className="table-selection">
              <thead>
                <tr>
                  <th data-field="assetName" style={{ width: "10px" }}>
                    {languageService("Asset")}
                  </th>

                  <th data-field="action" style={{ width: "10px" }}>
                    {languageService("Action")}
                  </th>
                </tr>
              </thead>
              <tbody style={{ background: "var(--fifth)", fontSize: "12px" }}>{rows}</tbody>
            </table>
          </Col>
          <Col md={1}></Col>
        </Row>
      </div>
    );
  }
  render() {
    const { showOEM } = this.state;
    return (
      <div className="mainContent">
        {!showOEM.show && (
          <Col md={12}>
            <div className="mainContent commonform" style={{ ...themeService(trackReportStyle.mainStyle), background: "transparent" }}>
              {
                <React.Fragment>
                  <h2 style={{ ...themeService(trackReportStyle.headingStyle), transform: "none", fontSize: "22px" }}>
                    {languageService("OEM Maintenance Record")}
                  </h2>
                  {this.renderTable()}
                </React.Fragment>
              }
            </div>
          </Col>
        )}
        {showOEM.show && (
          <OEMReportContainer
            titleStyle={{ paddingInline: "30px", paddingBlock: "20px" }}
            selectedAsset={showOEM.selectedAsset}
            OEMData={showOEM.OEMData}
            onClose={() => {
              this.setState({
                showOEM: {
                  show: false,
                  selectedAsset: null,
                  OEMData: null,
                },
              });
            }}
          />
          // <ViewReportOfOEMContainer selectedAsset={showOEM.selectedAsset} OEMData={showOEM.OEMData} />
        )}
      </div>
    );
  }
}
const getApplicationlookupss = curdActions.getApplicationlookupss;
let actionOptions = {
  create: false,
  update: false,
  read: true,
  delete: false,
  others: {
    getApplicationlookupss: getApplicationlookupss,
  },
};

let variables = {
  applicationlookupsReducer: {
    applicationlookupss: [],
  },
};

const LocomotiveOEMContainer = CRUDFunction(
  LocomotiveOEM,
  "LocomotiveOEMAssets",
  actionOptions,
  variables,
  ["applicationlookupsReducer"],
  "asset/getAllInspectableAssets",
);

export default LocomotiveOEMContainer;



// WEBPACK FOOTER //
// ./src/components/LocomotiveOEMRecord/index.jsx